export default __webpack_public_path__ + "static/media/7.47783af3.jpeg";